import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props, 'cardContent'>({
  name: 'HighlightIconStat',
  uniqId: 'lZJFUn',
})(
  (
    { brandColors, breakpoints, type, spacing, typography },
    props,
    classes
  ) => ({
    container: {
      background: brandColors.tintsOffWhite60,
      padding: ` ${spacing(5)} 0px`,
      '&.darkMode': {
        backgroundColor: brandColors.tintsHeroBlue10,
      },
    },
    card: {
      '&.MuiGrid2-root': {
        marginTop: spacing(3),
      },
      [breakpoints.down('md')]: {
        '&:nth-of-type(odd)': {
          [`& .${classes.cardContent}`]: {
            borderRightStyle: 'solid',
          },
        },
      },
      [breakpoints.up('md')]: {
        [`& .${classes.cardContent}`]: {
          borderRightStyle: 'solid',
        },
        '&:last-child': {
          [`& .${classes.cardContent}`]: {
            borderRightStyle: 'none',
          },
        },
      },
    },
    cardContent: {
      height: '100%',
      paddingRight: spacing(2),
      borderRightWidth: typography.pxToRem(1),
      [breakpoints.up('lg')]: {
        paddingRight: spacing(2),
      },
      borderRightColor: darkOrLightStyle(props)(
        'rgba(255, 255, 255, 0.30)',
        'rgba(0, 0, 0, 0.20)'
      ),
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      padding: spacing(0),
      marginBottom: spacing(2),
    },
    cardCopy: {
      color: brandColors.black,
      '&.darkMode': {
        color: brandColors.white,
      },
    },
    stat: {
      marginBottom: spacing(-1),
    },
    statTitle: {
      ...type['24_medium'],
      marginBottom: spacing(1),
      [breakpoints.up('sm')]: {
        ...type['20_medium'],
      },
      [breakpoints.up('lg')]: {
        ...type['24_medium'],
      },
    },
    statSubTitle: {
      color: brandColors.tintsNeutral20,
      '&.darkMode': {
        color: brandColors.tintsOffWhite40,
      },
    },
  })
);

export default useStyles;
